import {
  throttle
} from 'lodash'
import Account from 'accounting-js'

const HANDLE_FOCUS = 'V_PRICE_FOCUS'
const HANDLE_BLUR = 'V_PRICE_BLUR'
const HANDLE_INPUT = 'V_PRICE_INPUT'
const HANDLE_ELEMENT = 'V_PRICE_ELEMENT'

export default {
  bind (el, {
    value
  }) {
    if (el[HANDLE_INPUT]) {
      return
    }
    el[HANDLE_INPUT] = throttle(() => {
      let element = el[HANDLE_ELEMENT]
      let elValue = el.value
      console.info(elValue, value)
      if (element) {
        if (elValue > 0) {
          element.innerHTML = value === 0 || value === '0' ? Account.formatNumber(elValue * 1.0, {
            precision: 0
          }) : Account.formatNumber(elValue * 1.0, {
            precision: 2
          })
        } else {
          element.innerHTML = value === 0 || value === '0' ? '0' : '0.00'
        }
      }
    }, 100, {
      trailing: true
    })
    el[HANDLE_FOCUS] = () => {
      let element = el[HANDLE_ELEMENT]
      if (!element) {
        element = document.createElement('div')
        element.setAttribute('class', 'v-price')
        el.parentNode.appendChild(element)
        el[HANDLE_ELEMENT] = element
      }
      element.style.display = ''
      el[HANDLE_INPUT]()
    }
    el[HANDLE_BLUR] = () => {
      let element = el[HANDLE_ELEMENT]
      if (element) {
        element.style.display = 'none'
      }
    }
    el.addEventListener('focus', el[HANDLE_FOCUS], false)
    el.addEventListener('blur', el[HANDLE_BLUR], false)
    el.addEventListener('input', el[HANDLE_INPUT], false)
  },
  unbind (el) {
    if (el[HANDLE_INPUT]) {
      el.removeEventListener('focus', el[HANDLE_FOCUS])
      el.removeEventListener('blur', el[HANDLE_BLUR])
      el.removeEventListener('input', el[HANDLE_INPUT])
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/v-price.js